import React from 'react';
import { Container, Row, Col } from "reactstrap";


class Admin extends React.Component {
    render() { 
        return ( 
            <>
            <Container>
                <Row>
                    <Col xs="12" className="infos-right">
                    <h2 style={{color:"black",marginTop:"130px",fontWeight:"bold",fontSize:"47px"}}>Super Admin Dashboard</h2>
                    <div ></div>
                    </Col>
                </Row>
            </Container>
            </>
                     );
    }
}
 
export default Admin;